import React, { PropsWithChildren, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Add } from '@material-ui/icons';
import AssignmentWithPenIcon from '../../../common/icons/AssignmentWithPenIcon';
import AssignmentIcon from '@material-ui/icons/Assignment';
const useStyles = makeStyles({
  root: {
    border: props => `4px solid ${props.color}`,
    borderRadius: '4px',
    minHeight: '305px',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    '&:hover': {
      background: '#002537E5',
      opacity: '.9'
    }
  },
  button: {
    border: props => `2px solid ${props.color}`,
    borderRadius: '4px',
    cursor: 'pointer',
    width: '80%',
    zIndex: 1000,
    padding: '10px',
    marginBottom: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    textAlign: 'center'
  },
  icon: {
    color: (props: any) => props.color,
    fontSize: '10em'
  },
  text: {
    display: 'flex',
    alignItems: 'center',
    color: (props: any) => props.color
  }
});
interface AssignmentCardAddAssignmentProps {
  handleCustom(): any;
  handlePreMade(): any;
}
const AssignmentCardAddAssignment = (
  props: PropsWithChildren<AssignmentCardAddAssignmentProps>
) => {
  const [show, setShow] = useState(false);
  const classes = useStyles({
    color: '#1FAFFA'
  });
  const handleHover = (evt: any) => {
    if (evt.type === 'mouseleave') {
      setShow(false);
    } else {
      setShow(true);
    }
  };
  const { handleCustom, handlePreMade } = props;
  return (
    <div
      className={classes.root}
      onMouseEnter={handleHover}
      onMouseLeave={handleHover}
    >
      {show ? (
        <>
          <div onClick={handleCustom} className={classes.button}>
            <AssignmentWithPenIcon />
            &nbsp;
            <span>Custom Assignment</span>
          </div>
          <div onClick={handlePreMade} className={classes.button}>
            <AssignmentIcon />
            &nbsp;
            <span>Pre-made Assignment</span>
          </div>
        </>
      ) : (
        <>
          <Add className={classes.icon} />
          <span className={classes.text}>
            <b>Create Custom Assignment</b>
          </span>
        </>
      )}
    </div>
  );
};

export default AssignmentCardAddAssignment;
